import Button from '@material-ui/core/Button';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import React from 'react';
import { useHistory } from 'react-router-dom';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { HiShoppingCart } from 'react-icons/hi';
import { eshopPages } from '../../../pages/EshopPage';
import { getTheme } from '../../../theme';
import CollectionItemHeader from '../../layout/CollectionItemHeader';

const useStyles = makeStyles((theme) => {
  return {
    activeButton: {
      '&.Mui-disabled': {
        backgroundColor: theme.palette.secondary.main,
      },
    },
  };
});

const resolvePageName = (page) => {
  switch (page) {
    case eshopPages.NEW_DEPLOYMENT:
      return 'NEW DEPLOYMENT';
    case eshopPages.DEPLOYED_THEMATIC_PACKAGES:
      return 'Deployed Thematic Packages';
    default:
      return '';
  }
};

const ButtonsNavigation = (props) => {
  const history = useHistory();
  const classes = useStyles();
  return (
    <ButtonGroup
      size='large'
      color='secondary'
      aria-label='large outlined primary button group'
    >
      {
        Object
          .values(eshopPages)
          .map((eshopPage) => {
            return (
              <Button
                active
                disabled={ props.page === eshopPage }
                className={ classes.activeButton }
                key={ eshopPage }
                onClick={ () => {
                  history.push({
                    pathname: '/eshop',
                    search: `?page=${ eshopPage }`,
                  });
                } }
              >
                {resolvePageName(eshopPage)}
              </Button>
            );
          })
      }
    </ButtonGroup>
  );
};

const EshopPagesNavigation = (props) => {
  const { entries } = props;
  return (
    <div style={ { display: 'flex', flexDirection: 'row', alignItems: 'center', marginBottom: getTheme().spacing(4) } }>
      <HiShoppingCart
        style={ { color: getTheme().palette.secondary.dark, marginRight: getTheme().spacing(2) } }
        size={ 36 }
      />
      <CollectionItemHeader
        title='Eshop Management'
        subtitle={ entries !== undefined ? `Deployed Thematic Packages: ${ entries }` : '' }
        actions={ (
          <>
            <ButtonsNavigation { ...props } />
          </>
        ) }
      />
    </div>
  );
};

export default EshopPagesNavigation;
